import { apiClient } from '@/lib/api';
import type {
  CreatePlannerEventBody,
  PlannerEvent,
  PlannerResource,
  UpdatePlannerEventBody,
  ValidatePlannerEventBody,
  ValidatePlannerEventResponse,
} from '../types/planner';

const BASE = '/works-lite/planner';

export const plannerService = {
  getResources(teamId?: number): Promise<PlannerResource[]> {
    const params = teamId ? `?teamId=${teamId}` : '';
    return apiClient.get<PlannerResource[]>(`${BASE}/resources${params}`);
  },

  getEvents(start: string, end: string, teamId?: number, userId?: number): Promise<PlannerEvent[]> {
    const params = new URLSearchParams({ start, end });
    if (teamId) params.set('teamId', String(teamId));
    if (userId) params.set('userId', String(userId));
    return apiClient.get<PlannerEvent[]>(`${BASE}/events?${params}`);
  },

  createEvent(data: CreatePlannerEventBody): Promise<PlannerEvent> {
    return apiClient.post<PlannerEvent>(`${BASE}/events`, data);
  },

  updateEvent(id: number, data: UpdatePlannerEventBody): Promise<PlannerEvent> {
    return apiClient.patch<PlannerEvent>(`${BASE}/events/${id}`, data);
  },

  deleteEvent(id: number): Promise<{ success: boolean }> {
    return apiClient.delete<{ success: boolean }>(`${BASE}/events/${id}`);
  },

  validateEvent(data: ValidatePlannerEventBody): Promise<ValidatePlannerEventResponse> {
    return apiClient.post<ValidatePlannerEventResponse>(`${BASE}/validate`, data);
  },
};
